import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	padding-top: 40px;
`;

const StyledFiltersContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	width: 400px;
`;

const StyledSearchContainer = styled.div`
	margin-top: 30px;
`;

const StyledEmptyContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 380px;
	height: 463px;
	margin-top: 30px;

	${Text} {
		font-weight: 400;
		font-size: 18px;
		text-align: center;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledHeading = styled.div`
	display: flex;
	align-items: center;
	column-gap: 10px;
	padding: 0 0 20px 0;
	opacity: 0.75;
	user-select: none;
	pointer-events: none;

	${Text} {
		color: #ffffff;
		font-size: 16px;
		font-weight: 400;
	}
`;

const StyledSavedListContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	img {
		width: 14px;
		height: 14px;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
	margin-top: 30px;
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledEmptyContainer,
	StyledFiltersContainer,
	StyledHeading,
	StyledSavedListContainer,
	StyledSearchContainer,
};
